import { Component } from '@angular/core';
import { Hero } from '../../share/hero/hero';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-research',
  imports: [Hero, RouterLink],
  templateUrl: './research.html',
  styleUrl: './research.scss',
})
export class Research {}
